import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SaintKittsAndNevisFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15333'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15333)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33333L20 0H0V9.33333Z'
					fill='#1EC160'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V4.66663L0 14Z'
					fill='#DF2A40'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0.559743 17.7334L23.982 3.39021L19.4399 -3.7334L-3.98242 10.6097L0.559743 17.7334Z'
					fill='#FFD956'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.449231 16.1503L22.9731 1.80717L20.4496 -2.15039L-2.97266 12.1928L-0.449231 16.1503Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.5073 5.4582L13.832 6.50635L13.3938 5.34351L12.168 5.03801L13.1611 4.27029L13.0787 3.03333L14.1307 3.72169L15.3056 3.2627L14.9627 4.45586L15.7712 5.40915L14.5073 5.4582Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.88816 9.98493L6.21286 11.0331L5.7747 9.87024L4.54883 9.56474L5.54192 8.79702L5.45959 7.56006L6.51152 8.24842L7.6865 7.78944L7.34354 8.98259L8.15205 9.93588L6.88816 9.98493Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default SaintKittsAndNevisFlagIcon;
